<template>
    <div class="content">
        <h2>现场笔录</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <!--<el-col :span="24">
                    <el-form-item label="编号:" prop="bh">
                        <el-input style="width:200px; margin-right:10px;"
                        v-model="form.bh" disabled
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getWh(1)">获取编号</el-button>
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                <el-form-item label="许可项目:" prop="license_project">
                    <el-radio-group v-model="form.license_project">
                        <el-radio label='无' :aria-hidden="false">无</el-radio>
                        <el-radio label='有' :aria-hidden="false">有</el-radio>
                    </el-radio-group>
                    <el-input v-if="form.license_project == '有'"
                        v-model="form.license_project_text"
                        placeholder="请输入许可项目"
                        clearable
                        size="small" style="width:80%;margin-left:20px;"
                        />
                </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="检查机关:" prop="jcjg">
                        <el-input
                        v-model="jcjg"
                        placeholder="请输入"
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="陪同人:" prop="ptr">
                        <el-input
                        v-model="form.ptr"
                        placeholder="请输入陪同人"
                        clearable
                        size="small"  @input="getTet(1)" style="width:200px;"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="身份证号:" prop="sfzh">
                        <el-input
                        v-model="form.sfzh"
                        placeholder="请输入身份证号"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="陪同人职务:" prop="peitongrenzhiwu">
                        <el-input
                        v-model="form.peitongrenzhiwu"
                        placeholder="请输入陪同人职务"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="检查时间:"  required style="margin-bottom:0 !important;">
                        <el-form-item prop="xwrq" style="width:230px; float:left;">
                            <el-date-picker size="small"
                                v-model="form.xwrq"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>&nbsp;
                        </el-form-item>
                        <el-form-item prop="startTime" style="width:145px; float:left;">
                        <el-time-picker size="small" style="width:120px;"
                            placeholder="起始时间"  format="HH:mm"
                                value-format="HH:mm"
                            v-model="form.startTime">
                        </el-time-picker>&nbsp;至&nbsp;
                    </el-form-item>
                        <el-form-item prop="endTime" style="width:120px; float:left;">
                        <el-time-picker size="small" style="width:120px;"
                            placeholder="结束时间" format="HH:mm"
                                value-format="HH:mm"
                            v-model="form.endTime">
                        </el-time-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="检查地点:" prop="jianchadidian">
                        <el-input
                        v-model="form.jianchadidian"
                        placeholder="请输入检查地点"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="违法地点:" prop="weifadidian">
                        <el-input
                        v-model="form.weifadidian"
                        placeholder="请输入违法地点"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="笔录状态:" prop="blzt">
                        <el-radio-group v-model="form.blzt" @change="getBl" disabled>
                            <el-radio label='1' :aria-hidden="false">首次</el-radio>
                            <el-radio label='2' :aria-hidden="false">复查</el-radio>
                            <!--<el-radio label='3' :aria-hidden="false">无复查</el-radio>-->
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="监督员:"  required style="margin-bottom:0 !important;">
                        <el-form-item prop="ry1"  style="width:150px; float:left;margin-right:10px;">
                            <el-select v-model="form.ry1" size="small" placeholder="请选择监督员1" @change="getJdy(form.ry1,1)" value-key="xm" :key="Math.random()">
                                <el-option
                                v-for="(item, index) in jdyOptions"
                                :key="index"
                                :label="item.xm"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="ry2" style="width:150px; float:left;">
                            <el-select v-model="form.ry2" size="small" placeholder="请选择监督员2" @change="getJdy(form.ry2,2)" value-key="xm" :key="Math.random()">
                                <el-option
                                v-for="(item, index) in jdyOptions"
                                :key="index"
                                :label="item.xm"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">
                    <el-form-item label="违法行为:" prop="weifaxingwei">
                        <el-input type="textarea" rows="3"
                        v-model="form.weifaxingwei"
                        placeholder="请输入违法行为"
                        clearable
                        size="small"
                        />
                    </el-form-item>

                </el-col>-->
                <el-col :span="24">
                    <div class="addBl">
                        <div class="tlContainer">
                            <div class="section">
                                <h3>关键词推理（支持选择/手动输入）</h3>
                                <el-form ref="form" :model="form"> 
                                    <el-form-item label="选择关键词：">
                                        <el-select v-model="form.dalei" placeholder="请选择" size="small" @change="getXiaolei" style="width:150px;">
                                            <el-option
                                            v-for="item in options"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>  &nbsp;&nbsp;
                                        <el-select multiple :disabled="form.dalei ? false:true" size="small" v-model="form.xiaolei" placeholder="请选择" @change="getGjc" style="width:calc(100% - 265px);">
                                            <el-option
                                            v-for="item in options2"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.name">
                                            </el-option>
                                        </el-select>  
                                    </el-form-item>
                                </el-form>
                                <div class="input-group">
                                    <el-input size="small" v-model="otherGjc"   @input="renew($event)" clearable placeholder="手动输入关键词（多个用空格/逗号分隔）"></el-input>
                                    <el-button size="small" type="danger" @click="addManualKeywords">添加手动关键词</el-button>
                                </div>
                                <div id="selectedKeywords" style="margin-top:10px;">
                                    <strong>已选关键词：</strong> 
                                    <el-tag v-if="form.xiaolei" :key="tag" v-for="tag in gjcTags"  closable  :disable-transitions="false"  @close="handleClose(tag)" style="margin-right:10px;">  {{tag}}</el-tag>
                                </div>
                                <div style="margin:10px 0;text-align:right;">
                                    <el-button :disabled="gjcTags && gjcTags.length>0?false:true" size="small" type="primary" @click="subGjc">推理</el-button>
                                </div>
                            </div>
                            <!--<div class="section">
                                <h2>2. 模板匹配与生成</h2>
                                <p>当前使用模板：<strong>现场笔录模板</strong></p>
                                <el-input type="textarea" v-model="tlmbContent"  rows="5" ></el-input>
                                <el-button :disabled="isQueding?false:true" size="small" type="primary" @click="getTlhs" style="margin-top:10px;">生成推理话术</el-button>
                            </div>-->
                            <!--<div class="section" style="border-bottom:none;">
                                <h3>2. 结果预览与编辑</h3>
                                <div class="jieguo" v-loading="loadingR" style="position: relative; width: 100%;">
                                <el-input size="small" type="textarea" v-model="tlmbResult"   @input="renew($event)" placeholder='【等待生成】点击"生成推理话术"查看结果' rows="5"  ></el-input>
                                </div>
                                <el-button size="small" type="primary" @click="saveResult" style="margin-top:10px;">保存</el-button>
                            </div>-->
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="笔录引导语:" prop="jcnr">
                        <el-input type="textarea" rows="2" disabled style="margin-bottom:5px;"  v-model="form.inspectionContentTop"  placeholder="请选择监督员" size="small"/>
                        <div class="jieguo" v-loading="loadingR" style="position: relative; width: 100%;">
                        <el-input type="textarea" rows="4"
                        v-model="form.jcnr"
                        placeholder="请输入笔录引导语"
                        clearable
                        size="small"
                        /></div>
                    </el-form-item>
                </el-col>
                <!--
                <el-col :span="24">
                    <el-form-item label="检查内容:" prop="jcnr">
                        <el-input type="textarea" rows="7"
                        v-model="form.jcnr"
                        placeholder="请输入检查内容"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getNr(1)">检查内容</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="签名方式:" prop="qmfs">
                        <el-radio-group v-model="form.qmfs">
                            <el-radio label="1">电子签名及日期</el-radio>
                            <el-radio label="2">手工签名无日期</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>-->
                
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="saveBl('form')">生成现场笔录</el-button>
                        <!--<el-button type="primary" v-if="lsh" @click="submit('form')">现场笔录</el-button>-->
                        <el-button type="warning" v-if="isWs && form.blzt != '2'" @click="show()">预览</el-button>
                        <el-button type="warning" v-if="isWs2 && form.blzt == '2'" @click="show()">预览</el-button>
                        <!--<el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>-->
                    </el-form-item>
                </el-col>
            </el-row>            
        </el-form>
        
        <el-form>
        
        </el-form>
        <el-dialog title="检查内容" :visible.sync="open" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-row :gutter="40">
                    <el-col :span="7">
                        <ul class="zfmb" style="max-height:500px;overflow-y: auto;">
                            <li v-for="(item,index) in zfmbList" :key="index">
                            <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                            <div v-show="isActive == index" class="zfmb2">
                                <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">{{itema.mcjianxie}}</span>
                            </div>
                            </li>
                        </ul>
                    </el-col>
                    <el-col :span="17">
                        <el-form ref="form2" :model="form2">
                            <el-form-item label="" prop="jcnr">
                                <el-input type="textarea" rows="8" v-model="form2.jcnr" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="onSubmit('form2')">确定</el-button>
                    <el-button  size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="现场笔录" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','pcId','mid','form1','dwmc','xcbl1','xcbl2','fr','xcblList','xcblZt'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            sheng:'',
            xianqu:'',
            jcjg:'',
            form:{
                license_project:'无',
                license_project_text:'',
                sfzh:'',
                peitongrenzhiwu:'',
                jianchadidian:'',
                weifadidian:'',
                weifaxingwei:'',
                wfxxms:'',
                bh:'',
                xcblLsh:'',
                xwrq:'',
                startTime:'',
                endTime:'',
                blzt:'1',
                qmfs:'1',
                inspectionContentTop:'',
                jcnr:'',
                ptr:'',
                ry1:{},
                ry2:{},
                jdy1:'',
                jdy2:'',
                zfzh1:'',
                zfzh2:'',
            },
            // 新增两个独立对象存储笔录数据
            blForm1: {
                license_project:'无',
                license_project_text:'',
                sfzh:'',
                peitongrenzhiwu:'',
                jianchadidian:'',
                weifadidian:'',
                weifaxingwei:'',
                wfxxms:'',
                bh: '',
                xcblLsh:'',
                xwrq: '',
                startTime: '',
                endTime: '',
                blzt: '1',
                ptr: '',
                inspectionContentTop:'',
                jcnr: '',
                qmfs: '1',
                ry1: {},
                ry2: {},
                jdy1:'',
                jdy2:'',
                zfzh1:'',
                zfzh2:'',
            },
            blForm2: {
                license_project:'无',
                license_project_text:'',
                sfzh:'',
                peitongrenzhiwu:'',
                jianchadidian:'',
                weifadidian:'',
                weifaxingwei:'',
                wfxxms:'',
                bh: '',
                xcblLsh:'',
                xwrq: '',
                startTime: '',
                endTime: '',
                blzt: '2',
                ptr: '',
                inspectionContentTop:'',
                jcnr: '',
                qmfs: '1',
                ry1: {},
                ry2: {},
                jdy1:'',
                jdy2:'',
                zfzh1:'',
                zfzh2:'',
            },
            previousBlzt: '1', // 记录前一次笔录状态
            rules:{
                bh:[
                    { required: true, message: '现场笔录编号不能为空', trigger: 'blur' }
                ],
                xwrq:[
                    { required: true, message: '询问日期不能为空', trigger: ['change','blur'] }
                ],
                jdy1:[
                    { required: true, message: '监督员1不能为空', trigger: ['change','blur'] }
                ],
                jdy2:[
                    { required: true, message: '监督员2不能为空', trigger: ['change','blur'] }
                ],
                startTime:[
                    { required: true, message: '开始时间不能为空', trigger: ['change','blur'] }
                ],
                endTime:[
                    { required: true, message: '结束时间不能为空', trigger: ['change','blur'] }
                ],
                blzt:[
                    { required: true, message: '笔录状态不能为空', trigger: ['change','blur'] }
                ],
                jcnr:[
                    { required: true, message: '检查内容不能为空', trigger: 'blur' }
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ]
            },
            open:false,
            form2:{
                jcnr:''
            },
            wsUrl:'',
            isWs:false,
            isWs2:false,
            jdyOptions:[],
            jdyZfz1:'',
            jdyZfz2:'',            
            zfmbList:[],
            isActive:'0',
            isActive2:'-1',
            zfXX:[],
            titleWord:'',
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            wsUrl2:'',
            wsPdf2:'',
            docurl2:'',
            zfXX2:[],
            text:'',
            scBl:{},
            sc:false,
            dqZt:2,
            dqText:'',
            jianchaneirong:'',
            options:[],
            options2:[],
            xcblLsh:'',

            manualTags: [],  // 手动添加的标签
            gjcTags: [],     // 合并后的所有标签
            otherGjc:'',
            tlmbContent:'',
            tlmbResult:'',
            isQueding:false,
            loadingR:false,
            templateId:'',
            internalForm1: null, // 用于保存 form1 的副本
            lsh:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    
    watch: {
        pcId: {
            handler(newVal) {
            if (newVal) {
                this.lsh = newVal
                this.initBlForms()
            }
            },
            immediate: true
        },
        xcblList: {
            handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.initBlForms()
            }
            },
            deep: true,
            immediate: true
        },
        xcblZt: {
            handler(newVal) {
            if (newVal) {
                this.lsh = newVal
                this.initBlForms()
            }
            },
            immediate: true
        },
    },
    async created() {
        console.log(this.xcbl1,this.xcblList,297)
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.sheng = user.sheng
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl
        this.getJdys(this.cmid)

        //this.getWenshu() 
        axios({
            method: 'post',
            url: this.baseUrl+`/system/power/firstLevel`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {}
        })
        .then(response => {
            console.log(response.data);
            this.options = response.data.data
        })
        .catch(error => {
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        // 初始化 internalForm1 为 props 中 form1 的副本
        this.internalForm1 = { 
            sfzh:this.form1.sfzh?this.form1.sfzh:'',
            peitongrenzhiwu:this.form1.frzw?this.form1.frzw:'',
            jianchadidian:this.form1.dwdz?this.form1.dwdz:'',
            weifadidian:this.form1.dwdz?this.form1.dwdz:'',
            ...this.form1 
        };
    
        this.lsh = this.pcId || ''
        this.$nextTick(()=> {
            setTimeout(() => {
                // 初始化两个笔录对象
                this.initBlForms();
            },300)
        })
    },
    async mounted() {
    },
    methods: {
        // 初始化两个笔录对象
        initBlForms() {
            this.isWs = false
            this.url = ''
            // 初始化 blForm1 和 blForm2
            let tet = this.jcjg+'行政执法人员XXX、XXX着装出示'+this.sheng+'行政执法证(证号依次分为:XXX、XXX)，在XXX的陪同下依法进行检查，检查情况记录如下:'
            this.jianchaneirong = this.xcbl1 ? this.xcbl1 : ''
            const defaultData = {
                license_project:'无',
                license_project_text:'',
                sfzh:(this.form1 && this.form1.sfzh)?this.form1.sfzh:'',
                peitongrenzhiwu:(this.form1 && this.form1.frzw)?this.form1.frzw:'',
                jianchadidian:(this.form1 && this.form1.dwdz)?this.form1.dwdz:'',
                weifadidian:(this.form1 && this.form1.dwdz)?this.form1.dwdz:'',
                weifaxingwei:'',
                wfxxms:'',
                bh: new Date().getFullYear() + '-',
                xcblLsh:'',
                xwrq: this.getDate(new Date(), 'yyyy-MM-dd'),
                startTime: this.getDate(new Date(), 'hh:mm'),
                endTime: this.getDate(new Date(new Date().getTime() + 10 * 60 * 1000), 'hh:mm'),
                inspectionContentTop:tet,
                jcnr: this.jianchaneirong,
                ptr: this.fr || '',
                ry1: {},
                ry2: {},
                jdy1: '',
                jdy2: '',
                zfzh1: '',
                zfzh2: '',
                qmfs: '1',
                blzt: '1'
            };
            // 默认初始化两个表单为默认值
            this.blForm1 = { ...defaultData, blzt: '1',jcnr:this.xcbl1};
            this.blForm2 = { ...defaultData, blzt: '2',jcnr:this.xcbl2};

            console.log(this.xcblList,601)
            if (this.xcblList && this.xcblList.length > 0) {
                if (this.xcblList.length === 1 && this.xcblList[0].record_status === '1') {
                    // 单条记录且是首次笔录
                    const item = this.xcblList[0];
                    const { xwrq, startTime, endTime } = this.parseJianchaTime(item.jianchashijian);
                    // 查找对应的监督员对象
                    const jdy1Obj = this.jdyOptions.find(opt => opt.xm === item.zhubanrenyuan) || {};
                    const jdy2Obj = this.jdyOptions.find(opt => opt.xm === item.xiebanrenyuan) || {};
                    this.blForm1 = {
                        license_project: item.license_project ||'无',
                        license_project_text: item.license_project_text || '',
                        sfzh: item.sfzh || '',
                        peitongrenzhiwu:item.peitongrenzhiwu || '',
                        jianchadidian: item.jianchadidian || '',
                        weifadidian: item.weifadidian || '',
                        weifaxingwei: item.weifaxingwei || '',
                        bh: item.bianhao,
                        xcblLsh:item.xcbl_lsh || '',
                        xwrq: item.jianchashijian ? xwrq : '',
                        startTime: item.jianchashijian ? startTime : '',
                        endTime: item.jianchashijian ? endTime : '',
                        inspectionContentTop: item.inspectionContentTop ? item.inspectionContentTop : tet,
                        jcnr: item.inspectionContent || this.jianchaneirong,
                        ptr: item.peitongren || '',
                        ry1: jdy1Obj,  // 设置为对象
                        ry2: jdy2Obj,  // 设置为对象
                        jdy1: item.zhubanrenyuan || '',
                        jdy2: item.xiebanrenyuan || '',
                        zfzh1: item.zfzh1 || '',
                        zfzh2: item.zfzh2 || '',
                        qmfs: item.signs || '1',
                        blzt: '1'
                    };
                    this.wsUrl = item.url
                    this.isWs = true

                } else if (this.xcblList.length >= 2) {
                    // 至少两条记录，分别处理首次和复查
                    const form1Item = this.xcblList.find(i => i.record_status === '1');
                    const form2Item = this.xcblList.find(i => i.record_status === '2');

                    if (form1Item) {
                        const { xwrq, startTime, endTime } = this.parseJianchaTime(form1Item.jianchashijian);
                        // 查找对应的监督员对象
                        const jdy1Obj = this.jdyOptions.find(opt => opt.xm === form1Item.zhubanrenyuan) || {};
                        const jdy2Obj = this.jdyOptions.find(opt => opt.xm === form1Item.xiebanrenyuan) || {};

                        this.blForm1 = {
                            license_project: form1Item.license_project ||'无',
                            license_project_text: form1Item.license_project_text || '',
                            sfzh: form1Item.sfzh || '',
                            peitongrenzhiwu:form1Item.peitongrenzhiwu || '',
                            jianchadidian: form1Item.jianchadidian || '',
                            weifadidian: form1Item.weifadidian || '',
                            weifaxingwei: form1Item.weifaxingwei || '',
                            bh: form1Item.bianhao,
                            xcblLsh:form1Item.xcbl_lsh || '',
                            xwrq: form1Item.jianchashijian ? xwrq : '',
                            startTime: form1Item.jianchashijian ? startTime : '',
                            endTime: form1Item.jianchashijian ? endTime : '',
                            inspectionContentTop: form1Item.inspectionContentTop ? form1Item.inspectionContentTop : tet,
                            jcnr: form1Item.inspectionContent || this.jianchaneirong,
                            ptr: form1Item.peitongren || '',
                            ry1: jdy1Obj,  // 设置为对象
                            ry2: jdy2Obj,  // 设置为对象
                            jdy1: form1Item.zhubanrenyuan || '',
                            jdy2: form1Item.xiebanrenyuan || '',
                            zfzh1: form1Item.zfzh1 || '',
                            zfzh2: form1Item.zfzh2 || '',
                            qmfs: form1Item.signs || '1',
                            blzt: '1'
                        };
                        this.wsUrl = form1Item.url
                        this.isWs = this.xcblZt == '1' ? true :false
                    }

                    if (form2Item) {
                        const { xwrq, startTime, endTime } = this.parseJianchaTime(form2Item.jianchashijian);
                        const jdy1Obj = this.jdyOptions.find(opt => opt.xm === form2Item.zhubanrenyuan) || {};
                        const jdy2Obj = this.jdyOptions.find(opt => opt.xm === form2Item.xiebanrenyuan) || {};
                        this.blForm2 = {
                            license_project: form2Item.license_project ||'无',
                            license_project_text: form2Item.license_project_text || '',
                            sfzh:form2Item.sfzh || '',
                            peitongrenzhiwu:form2Item.peitongrenzhiwu || '',
                            jianchadidian:form2Item.jianchadidian || '',
                            weifadidian:form2Item.weifadidian || '',
                            weifaxingwei:form2Item.weifaxingwei || '',
                            bh: form2Item.bianhao,
                            xcblLsh:form2Item.xcbl_lsh || '',
                            xwrq: form2Item.jianchashijian ? xwrq : '',
                            startTime: form2Item.jianchashijian ? startTime : '',
                            endTime: form2Item.jianchashijian ? endTime : '',
                            inspectionContentTop: form2Item.inspectionContentTop ? form2Item.inspectionContentTop : tet,
                            jcnr: form2Item.inspectionContent || this.jianchaneirong,
                            ptr: form2Item.peitongren || '',
                            ry1: jdy1Obj,
                            ry2: jdy2Obj,
                            jdy1: form2Item.zhubanrenyuan || '',
                            jdy2: form2Item.xiebanrenyuan || '',
                            zfzh1: form2Item.zfzh1 || '',
                            zfzh2: form2Item.zfzh2 || '',
                            qmfs: form2Item.signs || '1',
                            blzt: '2'
                        };
                        this.wsUrl2 = form2Item.url
                        this.isWs2 = this.xcblZt == '2' ? true :false
                    }
                }
            }

            if(this.xcblZt == '2'){
                this.form = { ...this.blForm2 };
                this.xcblLsh = this.blForm2.xcblLsh 
            }else{
                this.form = { ...this.blForm1 };
                this.xcblLsh = this.blForm1.xcblLsh 
            }

            // 设置当前表单为首次笔录或根据状态切换
            //if (this.form.blzt === '1' || this.form.blzt === '3') {
                //this.form = { ...this.blForm1 };
                //this.xcblLsh = this.blForm1.xcblLsh 
            //} else if (this.form.blzt === '2') {
                //this.form = { ...this.blForm2 };
            //}
            console.log(this.form,704)            
            this.$forceUpdate()
        },
        parseJianchaTime(timeStr) {
            const match = timeStr.match(/(\d{4})年(\d{1,2})月(\d{1,2})日(\d{1,2})时(\d{1,2})分至(\d{1,2})时(\d{1,2})分/);
            if (!match) return { xwrq: '', startTime: '', endTime: '' };

            const [_, y, M, d, sh, sm, eh, em] = match;
            return {
                xwrq: `${y}-${M.padStart(2,'0')}-${d.padStart(2,'0')}`,
                startTime: `${sh.padStart(2,'0')}:${sm.padStart(2,'0')}`,
                endTime: `${eh.padStart(2,'0')}:${em.padStart(2,'0')}`
            };
        },
        // 保存当前表单到对应的笔录对象
        saveCurrentForm() {
            if (this.previousBlzt === '1' || this.previousBlzt === '3') {
                this.blForm1 = {...this.form};
                this.xcblLsh = this.blForm1.xcblLsh 
            } else if (this.previousBlzt === '2') {
                this.blForm2 = {...this.form};
                this.xcblLsh = this.blForm2.xcblLsh 
            }
        },
        
        getJdys(cmid){
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:cmid
                }
            })
            .then(async response => {
                this.jdyOptions = response.data.data
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
        },
        getJdy(jdy,val) {   
            console.log(this.form,778)
            if (val == 1) {
                if (this.form.ry1) {
                    this.form.jdy1 = jdy.xm;
                    this.form.jdy1zfzh = jdy.zfzh;
                    this.jdyZfz1 = jdy.zfzh;
                }
            } else {
                if (this.form.ry2) {
                this.form.jdy2 = jdy.xm;
                this.form.jdy2zfzh = jdy.zfzh;
                this.jdyZfz2 = jdy.zfzh;
                }
            }

            let tet = this.jcjg + '行政执法人员' + this.form.ry1.xm + '、' + this.form.ry2.xm +
                '着装出示' + this.sheng + '行政执法证(证号依次分为:' +
                this.form.ry1.zfzh + '、' + this.form.ry2.zfzh + ')，在' +
                this.form.ptr + '的陪同下依法进行检查，检查情况记录如下:'

            this.$set(this.form, 'inspectionContentTop', tet);         
        },
        getTet(val){
            if(this.form.inspectionContentTop.indexOf('的陪同下') != -1){
                let arr = this.form.inspectionContentTop.split('，在')
                let arr2 = arr[1].split('的陪同下')
                let text = arr[0]+'，在'+this.form.ptr+'的陪同下'+arr2[1]
                this.$set(this.form,'inspectionContentTop',text)
            }
        },
        getBl(newBlzt) {
            // 保存当前表单到之前的笔录对象
            this.saveCurrentForm();
            
            // 切换到新的笔录对象
            if (newBlzt === '1' || newBlzt === '3') {
                this.form = {...this.blForm1};
                if(!this.wsUrl){
                    this.getWenshu()
                }else{
                    this.isWs = true   
                }
            } else if (newBlzt === '2') {
                this.form = {...this.blForm2};
                if(!this.wsUrl2){
                    this.getWenshu2()
                }else{
                    this.isWs2 = true   
                }
            }
            
            // 确保表单的blzt属性为当前选中的状态
            this.form.blzt = newBlzt;
            
            // 更新前一次笔录状态
            this.previousBlzt = newBlzt;
            console.log(this.form,823)            
        },
        getWenshu(){  
            this.isWs = false 
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.pcId,
                    wsName:'现场笔录1'
                }
            })
            .then(response => {
                if(response.data.code==0){
                    if(response.data.msg){ 
                        this.isWs = true
                        let ws = response.data.msg
                        this.wsUrl = ws
                    }else{
                        this.isWs = false
                    }
                }else{
                    this.isWs = false
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });          
        },
        getWenshu2(){  
            this.isWs2 = false 
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.pcId,
                    wsName:'现场笔录2'
                }
            })
            .then(response => {
                if(response.data.code==0){
                    if(response.data.msg){ 
                        this.isWs2 = true
                        let ws = response.data.msg
                        this.wsUrl2 = ws
                    }else{
                        this.isWs2 = false
                    }
                }else{
                    this.isWs2 = false
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });          
        },
        async getScBl(val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(this.dwmc)}&dwmc2=&mid=${this.zfXX[0].dwmc_id}&type=shouji`)
            if(data.data && data.data[0].bl_nr){                
                let arr = data.data
                arr.forEach(item => {
                    if(item.lsh == this.zfXX[0].bl_lsh){
                        this.getText2(item.jdy1,item.jdy2,item.bl_xwr,item.bl_nr)
                    }
                })                
            }
        },
        getText2(jdy1,jdy2,ptr,nr){
            let jdyZfz1,jdyZfz2;
            let dm1,dm2;
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid
                }
            })
            .then(response => {
                let arrD = response.data.data
                arrD.forEach(item => {
                    if(item.xm === jdy1){
                        dm1 = item.dm
                        jdyZfz1 = item.zfzh
                    }
                    if(item.xm === jdy2){
                        dm2 = item.dm
                        jdyZfz2 = item.zfzh
                    }
                })
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
            let nr2 = nr?nr:''
            //let tet = this.jcjg+'行政执法人员'+jdy1+'、'+jdy2+'着装出示'+this.sheng+'行政执法证(证号依次分为:'+jdyZfz1+'、'+jdyZfz2+')，在'+ptr+'的陪同下依法进行检查，检查情况记录如下:\n'+nr2
            this.$set(this.blForm1,'jcnr',nr)
            // 如果当前是首次笔录，更新表单
            if (this.form.blzt === '1' || this.form.blzt === '3') {
                this.form = {...this.blForm1};
            }
        },
        async getWh(val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblBh&id=${this.lsh}`)
            if(data.data){
                if(data.data.errMessage){
                    this.$set(this.form,'bh',data.data.errMessage)
                }else{
                    let bh = new Date().getFullYear() + '-'
                    this.$set(this.form,'bh',bh)
                }
            }
        },
        async getNr(val){
            this.dqZt = val
            this.dqText = this.form.jcnr
            this.open = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getxcMb`)
            this.zfmbList = []
            if(data.data){
                this.zfmbList = data.data
            }
        },
        onSubmit(){
            this.open = false
            if(this.dqText.indexOf('\n') == -1){
                this.dqText = this.dqText + '\n'
            }else{
                this.dqText = this.dqText
            }
            this.$set(this.form,'jcnr',this.dqText+this.form2.jcnr) 
        },
        cancel(){
            this.form2 = {}
            this.open = false
        },
        show(){
            console.log(this.wsUrl,this.wsUrl2,974)
            if(this.wsUrl || this.wsUrl2){
                this.isWs = (this.form.blzt != '2' && this.wsUrl) ? true : false
                this.isWs2 = (this.form.blzt == '2' && this.wsUrl2) ? true : false
                let ws = this.form.blzt == '2' ? this.wsUrl2 : this.wsUrl
                if(ws){
                    let url = this.$router.resolve({
                        path:'/pdf2',
                        query:{
                            wsname:this.form.blzt == '2' ? 'xianchangbilu_fc':'xianchangbilu',
                            ws:encodeURIComponent(ws) // 手动 encode 一次
                        }
                    })
                    window.open(url.href,'_blank')
                }else{
                    this.$message.error('暂未制作本文书，不能预览！') 
                }
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl || this.docurl2){
                let url = this.sc ? this.docurl : this.docurl2
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf || this.wsPdf2){
                let url = this.sc ? this.wsPdf : this.wsPdf2
                window.open(url,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            let wsname = this.sc ? 'xianchangbilu.docx':'xianchangbilu_fc.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    if(this.sc){
                        this.wsPdf = data.data.pdfUrl
                    }else{
                        this.wsPdf2 = data.data.pdfUrl
                    }
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form2.jcnr.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.form2.jcnr){
              let zf = this.form2.jcnr.substr(this.form2.jcnr.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.form2.jcnr =  this.form2.jcnr + nr
            }else{
              this.form2.jcnr = itema.mc
            }
          }
        },
        saveBl(form){
       
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 提交前保存当前表单到对应笔录对象
                    this.saveCurrentForm();
                    console.log(this.form,725)
                    let that = this
                    this.loading = true

                    axios({
                        method: 'post',
                        url: this.baseUrl+`/system/power/sceneRecordsInfer`,
                        data:{
                            lsh: this.pcId,
                            xcblLsh:this.form.xcblLsh,
                            xcblsj:this.getDate(this.form.xwrq,'yyyy-MM-dd'),
                            xcblsjStart:this.form.startTime,
                            xcblsjEnd:this.form.endTime,
                            attendant:this.form.ptr,
                            recordStatus:this.form.blzt,
                            inspectionContentTop:this.form.inspectionContentTop,
                            inspectionContent:this.form.jcnr,
                            signatureMethod:this.form.qmfs,
                            supervisorOne:this.form.jdy1,
                            supervisorOneZfzh:this.form.jdy1zfzh || this.form.zfzh1,
                            supervisorTwo:this.form.jdy2,
                            supervisorTwoZfzh:this.form.jdy2zfzh || this.form.zfzh2, 
                            licenseProject:this.form.license_project || '无',
                            licenseProjectText:this.form.license_project_text || '',
                            sfzh:this.form.sfzh,
                            peitongrenzhiwu:this.form.peitongrenzhiwu,
                            jianchadidian:this.form.jianchadidian,
                            weifadidian:this.form.weifadidian,
                            weifaxingwei:this.form.weifaxingwei,
                            mid:this.mid,
                            cmid:this.cmid,
                            xm:this.xm,
                            dm:this.dm,
                            shi:this.shi,
                            xianqu:this.xianqu,
                            jcjg:this.jcjg
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        console.log(res,809)
                        this.loading = false
                        if(res.data.code == 0 && res.data.msg){
                            this.lsh = res.data.data.lsh
                            this.xcblLsh = res.data.data.xcbllsh
                            this.$set(this.form,'xcblLsh',res.data.data.xcbllsh)
                            this.submit(form)
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                    
                }
            })
        },
        submit(form){
            /*
            if(!this.form.bh.split('-')[1]){
                this.$message.error('请点击按钮获取编号')
                return false
            }
            */
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 提交前保存当前表单到对应笔录对象
                    this.saveCurrentForm();
                    console.log(this.form,725)
                    let that = this
                    this.loading = true

                    axios({
                        method: 'post',
                        url: this.baseUrl+`/xx/makeWenshu`,
                        data:{
                            lsh: this.pcId,
                            wsName:'现场笔录',
                            xcblLsh:this.form.xcblLsh,
                            xcblBh:this.form.bh,
                            xcblsj:this.getDate(this.form.xwrq,'yyyy-MM-dd'),
                            xcblsjStart:this.form.startTime,
                            xcblsjEnd:this.form.endTime,
                            attendant:this.form.ptr,
                            recordStatus:this.form.blzt,
                            inspectionContentTop:this.form.inspectionContentTop,
                            inspectionContent:this.form.jcnr,
                            signatureMethod:this.form.qmfs,
                            supervisorOne:this.form.jdy1,
                            supervisorOneZfzh:this.form.jdy1zfzh,
                            supervisorTwo:this.form.jdy2,
                            supervisorTwoZfzh:this.form.jdy2zfzh, 
                            licenseProject:this.form.license_project || '无',
                            licenseProjectText:this.form.license_project_text || '',
                            sfzh:this.form.sfzh,
                            peitongrenzhiwu:this.form.peitongrenzhiwu,
                            jianchadidian:this.form.jianchadidian,
                            weifadidian:this.form.weifadidian,
                            weifaxingwei:this.form.weifaxingwei,
                            mid:this.mid,
                            cmid:this.cmid,
                            xm:this.xm,
                            dm:this.dm,
                            shi:this.shi,
                            xianqu:this.xianqu,
                            jcjg:this.jcjg
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        console.log(res,809)
                        this.loading = false
                        if(res.data.code == 0 && res.data.data){
                            if(this.form.blzt != '2'){
                                this.isWs = true
                                this.wsUrl = res.data.data.url
                            }else{
                                this.isWs2 = true
                                this.wsUrl2 = res.data.data.url
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.show()
                            this.$emit('handleBack',this.form.jcnr,Number(this.form.blzt),this.lsh)
                            
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                    
                }
            })
        },
        //推理关键词页面相关接口
        getXiaolei(){
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/SecondaryLevel`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id:this.form.dalei
                }
            })
            .then(response => {
                console.log(response.data);
                this.options2 = response.data.data
                this.form2.xiaolei = ''
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        getGjc() {
            // 合并自动选中的关键词与手动输入的关键词
            const selectedTags = Array.isArray(this.form.xiaolei) ? this.form.xiaolei : [];
            this.gjcTags = [...new Set([...selectedTags, ...this.manualTags])];
            this.$forceUpdate();
        },
        handleClose(tag) {
            const isManual = this.manualTags.includes(tag);

            if (!isManual && this.form.xiaolei && Array.isArray(this.form.xiaolei)) {
                const index = this.form.xiaolei.indexOf(tag);
                if (index !== -1) {
                    this.form.xiaolei.splice(index, 1);
                }
            } else if (isManual) {
                const manualIndex = this.manualTags.indexOf(tag);
                if (manualIndex !== -1) {
                    this.manualTags.splice(manualIndex, 1);
                }
            }

            const selectedTags = Array.isArray(this.form.xiaolei) ? this.form.xiaolei : [];
            this.gjcTags = [...new Set([...selectedTags, ...this.manualTags])];
        },        
        addManualKeywords() {
            const manualTags = this.otherGjc
                .split(/[,，；;、\s]+/)
                .map(tag => tag.trim())
                .filter(tag => tag && !this.manualTags.includes(tag)); // 避免重复添加

            this.manualTags.push(...manualTags);
            const selectedTags = Array.isArray(this.form.xiaolei) ? this.form.xiaolei : [];
            this.gjcTags = [...new Set([...selectedTags, ...this.manualTags])];

            this.otherGjc = '';
            this.$forceUpdate();
        },        
        subGjc(){
            this.isQueding = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/template`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    templateName: this.form.blzt != '2' ? 'xcbl' : 'xcbl2'
                }
            })
            .then(async response => {
                console.log(response.data,this.gjcTags,823)
                this.loadingR = true
                const template = response.data.data.promptContent;
                let referto = await this.getReferto(this.gjcTags.join(','));
                this.templateId = response.data.data.id;
                this.internalForm1 = {
                    ...this.internalForm1,
                    referto,
                    secondaryLevel: this.gjcTags.join(',')
                };
                this.tlmbContent = this.replaceTemplate(template, this.internalForm1);

                console.log(this.tlmbContent,1412)
                this.$forceUpdate()
                setTimeout(() => {
                    this.getTlhs()
                }, 3000)
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        getReferto(val){
            return axios({
                method: 'post',
                url: this.baseUrl+`/system/power/referTo`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    keyword:val,
                }
            })
            .then(response => {
                console.log(response.data,845)
                return response.data.msg;
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
                return '';
            });
        },
        replaceTemplate(template, data) {
            return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
            return data[key] || match;
            });
        },
        getTlhs(){
            this.loadingR = true
            axios({
                method: 'post',
                url: this.baseUrl+`/system/power/xcblInference`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    templateId:this.templateId,
                    mid:this.mid,
                    inferentialRhetoric:this.tlmbContent,
                    lsh:this.pcId,
                }
            })
            .then(response => {
                this.loadingR = false
                console.log(response.data,819)
                this.tlmbResult = response.data.data.answer;
                console.log(this.tlmbResult)
                this.$forceUpdate()
                //let tet = this.jcjg+'行政执法人员'+this.form.jdy1+'、'+this.form.jdy2+'着装出示'+this.sheng+'行政执法证(证号依次分为:'+this.form.jdy1zfzh+'、'+this.form.jdy2zfzh+')，在'+this.form.ptr+'的陪同下依法进行检查，检查情况记录如下:\n'
                this.$set(this.form,'jcnr', this.tlmbResult)
            })
            .catch(error => {
                this.loadingR = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        saveResult() {
            if(this.tlmbResult){
                axios({
                    method: 'post',
                    url: this.baseUrl+`/system/power/template`,
                    headers: { // 添加请求头
                        "Content-Type": "application/json" // 明确声明为 JSON 格式
                    },
                    data: {
                        templateId:this.templateId,
                        lsh:this.xcblLsh,
                        mid:this.mid,
                        inferenceResults:this.tlmbResult
                    }
                })
                .then(response => {
                    console.log(response,880);
                    if(response.data.code == 0){
                        this.open = false
                        if(this.activeName == 'first'){
                            this.form2.xcbl1 = this.tlmbResult
                            this.save(0)
                        }else{
                            this.form2.xcbl2 = this.tlmbResult
                            this.save(0)
                        }
                    }
                })

                .catch(error => {
                    this.$message.error('获取数据失败！');
                    console.error('There was an error!', error);
                });
                
            }
            
        },
        renew(e){
            this.$forceUpdate()
        }, 
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-textarea.is-disabled .el-textarea__inner ,.content >>> .el-input.is-disabled .el-input__inner{ color: #333;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../../assets/images/wjj.png) no-repeat center left; margin-left: 10px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}


.tlContainer {
    max-width: 1200px;
    margin: 0 auto 12px;
    padding-bottom:10px;
    background: #eee;
    border-radius: 8px;
    overflow: hidden;
}
.header {
    padding: 20px;
    background: #007bff;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
}
.section {
    padding: 0 20px;
    /*border-bottom: 1px solid #e1dede;*/
}
.section h3 {
    font-size: 16px;
    margin: 10px 0;
    color: #333;
    text-align: left;
}
.input-group {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    width: 100%;
}
.section >>> .el-form-item{margin-bottom:15px;}
.section >>> .jieguo .el-loading-spinner{top:5vh}
.ajtl-item >>> .el-loading-spinner,.tl-border >>> .el-loading-spinner{top:0}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}
.jieguo >>> .el-loading-spinner{top:5%;}
</style>